import React, {Component} from 'react';
import {BASE_URL, META_SCREENS} from 'js/constants';
import {AppStore} from 'js/stores'; // singleton stores
import styles from 'css/screens/notfound.css';

/**
 * 404 screen
 */
export default class Notfound extends Component {
  /**
   * did mount
   */
  componentDidMount() {
    AppStore.pageView(META_SCREENS.notfound);
  }

  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    return (
      <section>
        <div className={styles.block}>
          大変申し訳ございません。<br />
          ご指定のページまたはファイルが見つかりませんでした。<br />
          <br />
          <br />
          <br />
          <a href={BASE_URL}>トップページへ</a>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/screens/notfound/index.js